{
  "id": "campaign-037",
  "name": "Crooked Promenade",
  "seed": "campaign:37",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....w_....x",
    "..T..w_..T..",
    ".n...w_...n.",
    "......_.....",
    "......_.x...",
    "......_K..~.",
    "..l.,,_..l~~",
    ".....,_...~.",
    "..b..._..b..",
    "......_.....",
    ".....~_.....",
    "____________",
    ".....~_.....",
    "......_.....",
    "....,._...,,",
    ".ss.,,_.....",
    "..s.,.......",
    "S..........."
  ],
  "critters": [
    {
      "kind": "dog",
      "x": 7,
      "y": 6
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 10
    },
    {
      "kind": "repair",
      "x": 10,
      "y": 10
    }
  ],
  "generatorVersion": 3,
  "level": 37,
  "biome": "park",
  "par": {
    "reel": 7269,
    "push": 5926,
    "selfPropelled": 5490,
    "tractor": 4925,
    "zeroTurn": 3667,
    "fairway": 2335
  },
  "routeTries": {
    "par": {
      "reel": 19,
      "push": 11,
      "selfPropelled": 8,
      "tractor": 18,
      "zeroTurn": 14,
      "fairway": 3
    }
  }
}
